import { defineWsRoute, event } from "@bigswiss-gmbh/fast-ws";


export const chatRoute = defineWsRoute([
  event("CHAT_START", (data) => {
    console.log("[chat] data =>", data);
  }),
]);
